"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = require("@chakra-ui/react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = _interopRequireWildcard(require("react"));

var _io = require("react-icons/io5");

var _reactIntl = require("react-intl");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// deps
const SelectMultiple = /*#__PURE__*/(0, _react2.memo)( /*#__PURE__*/(0, _react2.forwardRef)(function SelectMultiple(props, ref) {
  const {
    name,
    children,
    placeholder,
    isDisabled,
    isInvalid,
    shouldRenderFilter,
    isLazy,
    lazyBehavior,
    listMaxHeight,
    onChange,
    ...otherProps
  } = props;
  delete otherProps.isRequired;
  delete otherProps.label;
  const value = props.value === "" ? [] : props.value;
  const theme = (0, _react.useTheme)();
  const intl = (0, _reactIntl.useIntl)();
  const label = props.label ? props.label : function ({
    count
  }) {
    return placeholder ? intl.formatMessage({
      id: "s/xBMRSj"
    }, {
      count,
      placeholder
    }) : intl.formatMessage({
      id: "a6V+bTim"
    }, {
      count,
      placeholder
    });
  };
  const {
    isOpen,
    onOpen,
    onClose
  } = (0, _react.useDisclosure)();

  const childList = _react2.Children.toArray(children);

  const options = childList.filter(function (child) {
    return Boolean(child == null ? void 0 : child.props);
  }).map(function (child) {
    return { ...child.props,
      label: child.props.children
    };
  });

  function handleChange(event) {
    const {
      name,
      value: newValue
    } = event.target;
    const valueIndex = value.indexOf(newValue);
    onChange({
      target: {
        name,
        value: valueIndex > -1 ? [...value].filter(function (value, tempTalueIndex) {
          return tempTalueIndex !== valueIndex;
        }) : [...value, newValue]
      }
    });
  }
  /**
   *  Détermine si l'item est inclus dans filter
   * @param {string} item
   * @param {string} filter
   * @returns {boolean}
   */


  function includedInTheSearchFilter(item, filter = filter) {
    if (filter) {
      var _item$label;

      const filterable = (_item$label = item == null ? void 0 : item.label) != null ? _item$label : item.children;

      if ("string" === typeof filterable) {
        return filterable.toLowerCase().includes(filter.toLowerCase());
      }
    }

    return true;
  } // retourne true si toutes les options activées sont cochées


  const allSelected = options.filter(option => !option.isDisabled).every(option => value.includes(option.value));
  /* istanbul ignore next */

  function handleSelectAll() {
    if (allSelected) {
      onChange({
        target: {
          name,
          // on conserve les options désactivées et cochées
          value: options.filter(option => {
            return option.isDisabled && value.includes(option.value) && includedInTheSearchFilter(option, filter);
          }).map(option => option.value)
        }
      });
    } else {
      onChange({
        target: {
          name,
          // on conserve les options désactivées et cochées et on coche toutes les options activées
          value: options.filter(option => !option.isDisabled && includedInTheSearchFilter(option, filter) || option.isDisabled && value.includes(option.value)).map(option => option.value)
        }
      });
    }
  }

  const [filter, setFilter] = (0, _react2.useState)("");
  /**
   * Gère le changement de filtre.
   */

  function handleChangeFilter(event) {
    setFilter(event.target.value);
  }
  /**
   * Gère le clic sur sur touche dans le champ.
   * @type {import('react').KeyboardEventHandler<HTMLInputElement>}
   */


  function handleKeyDownFilter(event) {
    if ("Backspace" === event.key) {
      requestAnimationFrame(function () {
        // Empêche le dé-focus de champ lors de l'appui sur `Backspace`.

        /** @type {HTMLInputElement} */
        // @ts-ignore
        const element = event.target;
        element.focus();
      });
    }
  }
  /**
   * Gère l’appui sur le bouton de nettoyage du champ de filtre.
   */


  function handleClearFilter() {
    setFilter("");
  }

  const normalizedValue = (value != null ? value : []).filter(function (currentValue) {
    return options.some(function (tempOption) {
      return String(tempOption.value) === String(currentValue);
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [normalizedValue.map(function (currentValue, valueIndex) {
      const option = options.find(function (tempOption) {
        return String(tempOption.value) === String(currentValue);
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          ref: function (ref) {
            if (ref) {
              // Hack pour transmettre la nouvelle valeur au callback des tags.
              const valueIndex = value.indexOf(currentValue);
              ref._newValue = [...value].filter(function (value, tempTalueIndex) {
                return tempTalueIndex !== valueIndex;
              });
            }
          },
          type: "hidden",
          name: name,
          value: currentValue,
          "data-value": option.children
        })
      }, valueIndex);
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Menu, {
      isOpen: isOpen,
      isLazy: isLazy,
      lazyBehavior: lazyBehavior,
      closeOnSelect: false,
      variant: "outline",
      onClose: onClose,
      onOpen: onOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.MenuButton, { ...otherProps,
        ref: ref,
        as: _react.Button,
        isDisabled: isDisabled,
        variant: "outline",
        colorScheme: isInvalid ? "red" : "gray",
        w: "inherit",
        textAlign: "left",
        fontWeight: "normal",
        rightIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
          as: _io.IoChevronDown
        }),
        children: label({
          count: normalizedValue.length
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Portal, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.MenuList, {
          zIndex: theme.zIndices.tooltip,
          maxH: listMaxHeight,
          maxW: "100vw",
          overflowY: undefined !== listMaxHeight ? "auto" : undefined,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Box, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
              display: "flex",
              justifyContent: "flex-end",
              mr: "1rem",
              mt: ".5rem",
              mb: ".5rem",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Link, {
                "data-select-all": true,
                onClick: handleSelectAll,
                children: intl.formatMessage({
                  id: "dymKPlMV"
                }, {
                  allSelected
                })
              })
            }), shouldRenderFilter && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
              mr: "1rem",
              ml: "1rem",
              mt: ".5rem",
              mb: ".5rem",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.InputGroup, {
                size: "sm",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Input, {
                  pr: "2rem",
                  placeholder: intl.formatMessage({
                    id: "nvPT1zUS"
                  }),
                  "data-ignore-validation": true,
                  value: filter,
                  onChange: handleChangeFilter,
                  onKeyDown: handleKeyDownFilter
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.InputRightElement, {
                  width: "2rem",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
                    variant: "ghost",
                    size: "xs",
                    fontSize: "1rem",
                    color: "gray.600",
                    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
                      as: _io.IoCloseCircle
                    }),
                    onClick: handleClearFilter,
                    "aria-label": intl.formatMessage({
                      id: "rE/YZkl+"
                    })
                  })
                })]
              })
            })]
          }), options.filter(function (option) {
            return includedInTheSearchFilter(option, filter);
          }).map(function (option, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.MenuItem, {
              "data-item": true,
              onClick: function (event) {
                event.preventDefault();
                event.stopPropagation();
                handleChange({
                  target: {
                    name,
                    value: option.value
                  }
                });
              },
              isDisabled: option.isDisabled,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
                spacing: "1rem",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Checkbox, {
                  name: name,
                  value: option.value,
                  isChecked: value.includes(option.value),
                  isInvalid: option.isInvalid
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Text, {
                  children: option.children
                })]
              })
            }, option.value);
          })]
        })
      })]
    })]
  });
}));
SelectMultiple.displayName = "SelectMultiple";
SelectMultiple.propTypes = {
  label: _propTypes.default.func,
  isLazy: _propTypes.default.bool,
  name: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  listMaxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  lazyBehavior: _propTypes.default.string,
  value: _propTypes.default.any,
  isRequired: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  children: _propTypes.default.node,
  shouldRenderFilter: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
SelectMultiple.defaultProps = {
  isRequired: false,
  isDisabled: false,
  isLazy: false,
  isInvalid: false,
  shouldRenderFilter: true,
  value: [],
  onChange: () => {}
};
var _default = SelectMultiple;
exports.default = _default;